import React, { useContext, useState } from 'react';
import { Context } from '../../utils/context';
import "./Shop.css";
import ShopProducts from './ShopProducts/ShopProducts';

function Shop() {
  const { products } = useContext(Context);
  const [sortingOption, setSortingOption] = useState("default");

    const sortProducts = (products: any, option: any) => {
      try {
        const productsArray = products.data;

        switch (option) {
          case "lowest":
            return productsArray?.slice()?.sort((a: any, b: any) => a.attributes.price - b.attributes.price);
          case "highest":
            return productsArray?.slice()?.sort((a: any, b: any) => b.attributes.price - a.attributes.price);
            case "name-az":
              return productsArray.slice().sort((a: any, b: any) => {
                const titleA = a.attributes.title || ""; 
                const titleB = b.attributes.title || ""; 
                return titleA.localeCompare(titleB);
              });
          case "name-za":
            return productsArray.slice().sort((a: any, b: any) => {
              const titleA = a.attributes.title || "";
              const titleB = b.attributes.title || ""; 
              return titleB.localeCompare(titleA);
            });
            case "default":
              return productsArray;
        }
      } catch (error) {
        console.error("Sorting error:", error);
        return products; 
      }
  }

  const handleSortingChange = (e: any) => {
    setSortingOption(e.target.value);
  }

  const sortedProducts = sortProducts(products, sortingOption);
  console.log(sortedProducts);

  return (
    <div className='category-main-container'>
      <div className="category-layout">
        <div className="sort-selection">
          <form action="#">
            <label htmlFor="sort" style={{marginRight:"10px"}}>Sort by : </label>
            <select
              name="sort"
              id="sort"
              className='sort-selection--style'
              value={sortingOption}
              onChange={handleSortingChange}
            >
              <option value="default">Default</option>
              <option value="lowest">Price (lowest)</option>
              <option value="highest">Price (highest)</option>
              <option value="name-az">Name (a-z)</option>
              <option value="name-za">Name (z-a)</option>
            </select>
          </form>
        </div>
        <ShopProducts products={sortedProducts} titleText="Shop" />
      </div>
    </div>
  )
}

export default Shop;
